<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="70px">
            <el-form-item label="酒店名称" prop="hotelName">
                <el-input v-model="searchForm.hotelName" placeholder="请输入酒店名称" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="订单号" prop="orderNo">
                <el-input v-model="searchForm.orderNo" placeholder="订单号" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="住客姓名" prop="customerName">
                <el-input v-model="searchForm.customerName" placeholder="请输入住客姓名" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="联系手机" prop="customerMobile">
                <el-input v-model="searchForm.customerMobile" placeholder="请输入联系手机" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择" style="width: 120px">
                    <el-option label="未支付" :value="0"></el-option>
                    <el-option label="已支付" :value="1"></el-option>
                    <el-option label="已取消" :value="2"></el-option>
                    <el-option label="入住中" :value="3"></el-option>
                    <el-option label="已完成入住" :value="4"></el-option>
                    <el-option label="退房中" :value="5"></el-option>
                    <el-option label="已退房" :value="6"></el-option>
                    <el-option label="取消预定" :value="8"></el-option>
                    <el-option label="全部退款" :value="12"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="支付方式" prop="payWay">
                <el-select v-model="searchForm.payWay" placeholder="请选择" style="width: 120px">
                    <el-option label="微信支付" :value="1"></el-option>
                    <el-option label="企业预定" :value="3"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center" fixed="left"></el-table-column>
            <el-table-column prop="createTime" label="预定时间" width="200"></el-table-column>
            <el-table-column prop="orderNo" label="订单号" width="200"></el-table-column>
            <el-table-column prop="statusDesc" label="状态"  width="130">
                <template slot-scope="{ row }">
                    <el-tag type="danger" v-if="row.status == 2">{{ row.statusDesc }}</el-tag>
                    <el-tag v-else>{{ row.statusDesc }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="payWayDesc" label="支付方式"  width="130">
                <template slot-scope="{ row }">
                    <el-tag>{{ row.payWayDesc }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="hotelName" label="酒店名称" width="230" show-overflow-tooltip></el-table-column>
            <el-table-column prop="roomTypeName" label="房型" width="120"></el-table-column>
            <!-- <el-table-column prop="customerName" label="住客姓名" width="120"></el-table-column>
            <el-table-column prop="customerMobile" label="联系手机" width="120"></el-table-column> -->
            <el-table-column prop="lastPay" label="支付金额" width="130"></el-table-column>
            <el-table-column prop="roomQty" label="房间数量" width="130"></el-table-column>
            <el-table-column prop="days" label="预定天数" width="120"></el-table-column>
            <el-table-column prop="shareUsername" label="推广账户" width="120"></el-table-column>
            <el-table-column prop="estimatedCheckIn" label="开始时间" width="170"></el-table-column>
            <el-table-column prop="estimatedCheckOut" label="结束时间"  width="170"></el-table-column>
           
            <el-table-column prop="action" label="操作" fixed="right" width="200">
                <template slot-scope="{ row }">
                    <el-button size="mini" type="text" @click="handleCheckIn(row)" v-if="row.status == 1">办理入住</el-button>
                    <el-button size="mini" type="text" @click="handleShowDetail(row)">查看详情</el-button>
                    <el-button size="mini" type="text" style="color: red;" @click="handleCancelOrder(row)" v-if="row.status == 1">取消预订</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

        <!-- 登记入住 -->
        <el-dialog :visible.sync="isShow" :title="!isDetail ? '登记入住' : '查看详情'" width="820px" append-to-body destroy-on-close
            :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="modelForm" :model="modelForm" inline label-width="100px" style="margin: 0 20px" size="small" :rules="modelFormRules" v-if="!isDetail">
                <div class="legend-title">基本信息</div>
                <el-form-item label="订单号" prop="orderNo">
                    <el-input type="text" v-model="modelForm.orderNo" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="房型" prop="roomTypeName">
                    <el-input type="text" v-model="modelForm.roomTypeName" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="房间数量" prop="roomQty">
                    <el-input type="text" v-model="modelForm.roomQty" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="退房时间" prop="estimatedCheckOut">
                    <el-input type="text" v-model="modelForm.estimatedCheckOut" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="支付方式" prop="payWayDesc">
                    <el-input type="text" v-model="modelForm.payWayDesc" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="用户备注" prop="remark">
                    <el-input type="text" v-model="modelForm.remark" disabled style="width: 250px"></el-input>
                </el-form-item>
                
                <div class="legend-title">入驻信息</div>
                <el-form-item label="姓名" prop="customerName">
                    <el-input type="text" v-model="modelForm.customerName" placeholder="请输入姓名" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idNumber">
                    <el-input type="text" v-model="modelForm.idNumber" placeholder="请输入身份证号码" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="customerMobile">
                    <el-input type="text" v-model="modelForm.customerMobile" placeholder="请输入电话号码" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="金额" prop="lastPay">
                    <el-input type="text" v-model="modelForm.lastPay" disabled placeholder="请输入金额" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="酒店备注" prop="hotelRemarks">
                    <el-input type="textarea" v-model="modelForm.hotelRemarks" placeholder="请输入酒店备注" style="width: 250px"></el-input>
                </el-form-item>

                <div v-if="(modelForm.status == 1) || modelForm.status == 3 || modelForm.status == 4 || modelForm.status == 5 || modelForm.status == 6">
                    <div class="divider-line">
                        <el-divider content-position="left">入住房间</el-divider>
                        <!-- <el-button type="primary" size="small" @click="handleAddRoom">添加</el-button> -->
                    </div>
                    <div v-for="(item,key) in modelForm.roomOrderVoList" :key="key">
                        <el-form-item label="楼层" :prop="'roomOrderVoList.' + key +'.floor'" :rules="modelFormRules.floor">
                            <el-select v-model="item.floor" placeholder="请选择楼层" style="width: 250px" @change="$event => handleSelectFloor($event, item, key)">
                                <el-option v-for="item in floorList" :key="item.id" :label="item.floorName" :value="item.floorName"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="房间" :prop="'roomOrderVoList.' + key + '.roomNo'" :rules="modelFormRules.roomNo">
                            <el-select v-model="item.roomNo" placeholder="请选择楼层" style="width: 180px;margin-right: 10px;" @visible-change="$event => handleVisibleChange($event,item)">
                                <el-option v-for="item in roomList" :key="item.id" :label="item.roomNo" :value="item.roomNo"></el-option>
                            </el-select>
                            <!-- <el-button type="danger" size="small" @click="handleDelRoom(key)">删除</el-button> -->
                        </el-form-item>
                    </div>
                </div>
               
                
            </el-form>

            <el-form :model="modelForm" inline label-width="100px" style="margin: 0 20px" size="small" disabled v-if="isDetail" key="detail">
                <div class="legend-title">基本信息</div>
                <el-form-item label="预定时间" prop="paymentTime">
                    <el-input type="text" v-model="modelForm.paymentTime" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="订单号" prop="orderNo">
                    <el-input type="text" v-model="modelForm.orderNo" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="支付方式" prop="payWayDesc">
                    <el-input type="text" v-model="modelForm.payWayDesc" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="customerName">
                    <el-input type="text" v-model="modelForm.customerName" placeholder="请输入姓名" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idNumber">
                    <el-input type="text" v-model="modelForm.idNumber" placeholder="请输入身份证号码" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="customerMobile">
                    <el-input type="text" v-model="modelForm.customerMobile" placeholder="请输入电话号码" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="用户备注" prop="remark">
                    <el-input type="text" v-model="modelForm.remark" style="width: 250px"></el-input>
                </el-form-item>
                <div class="legend-title">订单信息</div>
                <el-table border size="small" :data="orderDetail" style="margin-bottom: 20px;">
                    <el-table-column prop="hotelName" label="酒店名称" width="230" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="days" label="预定天数" width="100"></el-table-column>
                    <el-table-column prop="roomTypeName" label="房型" width="100"></el-table-column>
                    <el-table-column prop="roomQty" label="房间数" width="100"></el-table-column>
                    <el-table-column prop="lastPay" label="支付金额(元)" width="100"></el-table-column>
                    <el-table-column prop="discount" label="优惠(元)" width="100"></el-table-column>
                    <el-table-column prop="estimatedCheckIn" label="入住时间" width="120"></el-table-column>
                    <el-table-column prop="estimatedCheckOut" label="退房时间"  width="120"></el-table-column>
                </el-table>
            </el-form>
            <div slot="footer" v-if="isDetail">
                <el-button type="primary" size="small" @click="isShow = false;">关闭</el-button>
            </div>
            <div slot="footer" v-else>
                <el-button type="text" size="small" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
            
        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        const validatePhone = (rule, value, callback) => {
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!reg.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        }
        const validatePrice = (rule, value, callback) => {
            if (
                (value < 0.01 && value) ||
                !value ||
                !/^\d+(\.\d{1,2})?$/.test(value)
            ) {
                callback(new Error("金额不能小于0.01元且最多只能保留两位小数"));
            } else {
                callback();
            }
        };
        var validateCard = (rule, value, callback) => {
            if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                callback(new Error('身份证号格式错误且不能为空'));
            } else {

                callback();
            }
        };
        return {
            searchForm: {
                orderNo: "",
                payWay: "",
                hotelName: "",
                customerName: "",
                customerMobile: "",
                status: "",
                pageSize: 10,
                pageNumber: 1,
            },
            isLoading: false,
            tableData: [],
            total: 0,
            isShow: false,
            isDetail: false,
            modelForm: {
                roomOrderVoList: [],
                customerName: "",
                idNumber:"",
                lastPay: ''
            },
            modelFormRules: {
                customerName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                idNumber: [{ required: true, validator: validateCard, trigger: 'blur' }],
                customerMobile: [{ required: true, validator: validatePhone, trigger: "blur" }],
                lastPay: [{ required: true, validator: validatePrice, trigger: "blur" }],
                floor: [{ required: true, message: "请选择楼层", trigger: "blur" }],
                roomNo: [{ required: true, message: "请选择房间号", trigger: "blur" }],
            },
            floorList: [],
            roomList: [],
            hotelId: null,
            submitLoading: false,
            orderDetail: []
        }
    },
    created() {
        this.getTableData();
    },
    methods: {
        handleSubmit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest("/api/order/expressCheckIn", this.modelForm)
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success(data.msg);
                                this.isShow = false;
                                this.getTableData();
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                }
            })
        },
        handleVisibleChange(event,item) {
            if(!item.floor) {
                this.$message.warning("请先选择楼层");
                return;
            }
            if(event) {
                this.getRoomList(item.floor);
            }
        },
        handleSelectFloor(floor,item,key) {
            item.roomNo = "";
            this.modelForm.roomOrderVoList.splice(key, 1, item);
            // console.log(this.modelForm.roomOrderVoList)
            this.getRoomList(floor);
        },
        handleAddRoom() {
            this.modelForm.roomOrderVoList.push({
                roomNo: "",
                floor: ""
            });
        },
        handleDelRoom(key) {
            this.modelForm.roomOrderVoList.splice(key, 1);
        },
        handleShowDetail(row) {
            this.isDetail = true;
            this.getRequest(`/api/order/get/${row.id}`)
            .then(res => {
                let data = res.data;
                if(data.code == 200) {
                    data.data.roomOrderVoList = data.data.roomOrderVoList || [];
                    if(data.data.roomOrderGuestInfoVoList) {
                        data.data.customerName = data.data.roomOrderGuestInfoVoList[0].name;
                        data.data.customerMobile = data.data.roomOrderGuestInfoVoList[0].phone;
                        data.data.idNumber = data.data.roomOrderGuestInfoVoList[0].idNumber;
                    }
                    this.modelForm = data.data;
                    this.orderDetail = [this.modelForm];
                    this.isShow = true;
                }
            })
        },
        handleCancelOrder(item) {
            this.$confirm("请确认已与客户协商完成，款项需要酒店自行安排自行退回！是否确认取消该预定订单?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.postRequest(`/api/order/cancelScheduled`, {
                    orderNo: item.orderNo
                }).then((res) => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.$message.success(data.msg);
                        this.getTableData();
                    }
                });
            });
        },
        handleCheckIn(row) {
            this.hotelId = row.hotelId;
            this.getFloorList();
            this.isDetail = false;
            this.getRequest(`/api/order/get/${row.id}`)
            .then(res => {
                let data = res.data;
                if(data.code == 200) {
                    data.data.roomOrderVoList = data.data.roomOrderVoList || [];
                    if(data.data.roomOrderGuestInfoVoList) {
                        data.data.customerName = data.data.roomOrderGuestInfoVoList[0].name;
                        data.data.customerMobile = data.data.roomOrderGuestInfoVoList[0].phone;
                        data.data.idNumber = data.data.roomOrderGuestInfoVoList[0].idNumber;
                    }
                    
                    this.modelForm = data.data;
                    this.isShow = true;
                }
            })
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                orderNo: "",
                payWay: "",
                hotelName: "",
                customerName: "",
                customerMobile: "",
                status: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/api/order/page", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
        getRoomList(floor) {
            this.isLoading = true;
            this.postRequest("/api/room/getAllList", {
                hotelId: this.hotelId,
                floor: floor
            }).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.roomList = data.data;
                }
            });
        },
        getFloorList() {
            this.getRequest(`/floor/getHotelFloor?hotelId=${this.hotelId}`)
                .then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.floorList = data.data;
                    }
                })
        },

    },
}
</script>
<style type="less">
@import url("./index.less");
</style>


